import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import HeroMetricCard from '../../pages/protected/deal/dashboard/HeroMetricCard';
import MetricCard from '../../pages/protected/deal/dashboard/MetricCard';

/**
 * Fixed illustrative figures. These components do not load a deal or call an API.
 */
const ProductPreview: React.FC<{ cornerInset?: boolean }> = ({ cornerInset = false }) => {
  return (
    <Box
      component="section"
      aria-labelledby="preview-title"
      sx={{
        p: { xs: 2, md: 2.5 },
        pt: cornerInset ? { xs: 2, md: 16 } : { xs: 2, md: 2.5 },
        borderRadius: 3,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 6,
      }}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', mb: 0.5 }}>
        <Typography id="preview-title" component="h2" variant="h6" sx={{ fontWeight: 800, mr: 0.5 }}>
          123 Example Street
        </Typography>
        <Chip size="small" color="success" label="Modeled Deal Grade A" />
        <Chip size="small" variant="outlined" label="Illustrative example" />
      </Box>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
        Sample figures, not a live analysis and not a recommendation to purchase.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 1.5,
          mb: 1.5,
        }}
      >
        <HeroMetricCard label="Projected net profit" value="$48,500" />
        <HeroMetricCard label="Cash required" value="$62,000" />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.5 }}>
        <MetricCard label="ARV" value="$250,000" footnote="Illustrative example" />
        <MetricCard label="Comp indication" value="$246,000" footnote="Not a recommendation to purchase" />
      </Box>
    </Box>
  );
};

export default ProductPreview;
